import { Check } from 'lucide-react';
import React, { useState } from 'react';
import { ReactNode } from 'react';

import { Input } from '@/shared/ui/input';
import { cn } from '@/shared/utils';

export type EditableTitleProps = {
  children: ReactNode;
  trigger: ReactNode;
  initialTitle: string | undefined | null;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  readonly?: boolean;
  className?: string;
};

export const EditableTitle = ({
  children,
  trigger,
  initialTitle,
  onChange,
  placeholder,
  readonly,
  className,
}: EditableTitleProps) => {
  const [title, setTitle] = useState(initialTitle ?? '');
  const [isEditing, setIsEditing] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
    onChange(event);
  };

  if (readonly) {
    return children;
  }

  return (
    <div className="flex gap-1">
      {isEditing ? (
        <div className={cn('min-w-full md:min-w-96', className)}>
          <Input
            value={title}
            autoFocus
            onChange={handleChange}
            placeholder={placeholder}
          />
        </div>
      ) : (
        children
      )}

      <div>
        {React.isValidElement(trigger) &&
          React.cloneElement(
            isEditing ? <Check /> : trigger,
            {
              ...trigger.props,
              className: cn('cursor-pointer', trigger.props.className),
              onClick: () => setIsEditing((prevState) => !prevState),
            },
            trigger.props.children,
          )}
      </div>
    </div>
  );
};
